(() => {
  if (window.__iconicPdpLocalizationModalInitialized) return;
  window.__iconicPdpLocalizationModalInitialized = true;

  const getModal = (trigger) => {
    const controls = trigger && trigger.getAttribute('aria-controls');
    if (controls) return document.getElementById(controls);
    return document.querySelector('[data-pdp-localization-modal]');
  };

  const syncSelectFlag = (select) => {
    if (!select) return;

    const option = select.options && select.options[select.selectedIndex];
    const flagUrl = option && option.dataset ? option.dataset.flagUrl || '' : '';
    const flagEmoji = option && option.dataset ? option.dataset.flag || '' : '';
    const alt = option && option.dataset ? option.dataset.flagAlt || '' : '';
    const wrap = select.closest('.pdp-localization-modal__select-wrap');
    const flagWrap = wrap && wrap.querySelector('[data-pdp-select-flag]');
    const flagImage = flagWrap && flagWrap.querySelector('[data-pdp-select-flag-image]');
    const flagEmojiNode = flagWrap && flagWrap.querySelector('[data-pdp-select-flag-emoji]');

    if (!flagWrap) return;

    if (flagUrl && flagImage) {
      flagImage.src = flagUrl;
      flagImage.alt = alt || '';
      flagImage.removeAttribute('hidden');

      if (flagEmojiNode) {
        flagEmojiNode.textContent = '';
        flagEmojiNode.setAttribute('hidden', 'hidden');
      }

      flagWrap.removeAttribute('hidden');
      return;
    }

    if (flagEmoji && flagEmojiNode) {
      if (flagImage) {
        flagImage.removeAttribute('src');
        flagImage.alt = '';
        flagImage.setAttribute('hidden', 'hidden');
      }

      flagEmojiNode.textContent = flagEmoji;
      flagEmojiNode.removeAttribute('hidden');
      flagWrap.removeAttribute('hidden');
      return;
    }

    if (flagImage) {
      flagImage.removeAttribute('src');
      flagImage.alt = '';
      flagImage.setAttribute('hidden', 'hidden');
    }

    if (flagEmojiNode) {
      flagEmojiNode.textContent = '';
      flagEmojiNode.setAttribute('hidden', 'hidden');
    }

    flagWrap.setAttribute('hidden', 'hidden');
  };

  const syncModalFlags = (modal) => {
    if (!modal) return;
    modal.querySelectorAll('[data-pdp-localization-flag-select]').forEach(syncSelectFlag);
  };

  let lastActiveElement = null;

  const openModal = (trigger) => {
    const modal = getModal(trigger);
    if (!modal) return;
    lastActiveElement = document.activeElement;
    modal.hidden = false;
    syncModalFlags(modal);
    document.documentElement.classList.add('pdp-localization-modal-is-open');
    document.body.classList.add('pdp-localization-modal-is-open');
    const dialog = modal.querySelector('.pdp-localization-modal__dialog');
    if (dialog) dialog.focus();
  };

  const closeModal = (modal) => {
    const activeModal = modal || document.querySelector('[data-pdp-localization-modal]:not([hidden])');
    if (!activeModal) return;
    activeModal.hidden = true;
    document.documentElement.classList.remove('pdp-localization-modal-is-open');
    document.body.classList.remove('pdp-localization-modal-is-open');
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-pdp-localization-open]');
    if (openTrigger) {
      event.preventDefault();
      openModal(openTrigger);
      return;
    }

    const closeTrigger = event.target.closest('[data-pdp-localization-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeModal(closeTrigger.closest('[data-pdp-localization-modal]'));
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-pdp-localization-flag-select]');
    if (select) syncSelectFlag(select);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  document.querySelectorAll('[data-pdp-localization-modal]').forEach(syncModalFlags);
})();
